import {
  gakumonData,
  ritsuKubunData,
  areaData,
  SDGsData,
} from "@/store/app.config";

export class AppData {
  /**
   * 検索結果 学問分野データ
   */
  public static gakumonData: gakumonData[][] = [
    [
      {
        cls: ["Gakumon_210", "-Gakumon-type01"],
        keitou: "文学・人文系統",
        gakka: [
          "日本文学",
          "外国文学",
          "史学･地理学",
          "哲学･倫理･宗教学",
          "心理学･行動科学",
          "文化･教養学",
          "人間科学",
        ],
        imgPath: "./images/icon_gakumonType01Link.svg",
        cd: ["gc010", "gc020", "gc030", "gc040", "gc050", "gc060", "gc070"],
      },
    ],
    [
      {
        cls: ["Gakumon_220", "-Gakumon-type01"],
        keitou: "語学・言語学系統",
        gakka: ["外国語学", "日本語学", "言語学"],
        imgPath: "./images/icon_gakumonType01Link.svg",
        cd: ["gc080", "gc083", "gc086"],
      },
    ],
    [
      {
        cls: ["Gakumon_230", "-Gakumon-type01"],
        keitou: "教育系統",
        gakka: ["教育"],
        imgPath: "./images/icon_gakumonType01Link.svg",
        cd: ["gc090"],
      },
    ],
    [
      {
        cls: ["Gakumon_240", "-Gakumon-type01"],
        keitou: "美術・デザイン・芸術系統",
        gakka: ["美術･デザイン･芸術学"],
        imgPath: "./images/icon_gakumonType01Link.svg",
        cd: ["gc100"],
      },
    ],
    [
      {
        cls: ["Gakumon_250", "-Gakumon-type01"],
        keitou: "音楽系統",
        gakka: ["音楽"],
        imgPath: "./images/icon_gakumonType01Link.svg",
        cd: ["gc105"],
      },
    ],
    [
      {
        cls: ["Gakumon_260", "-Gakumon-type02"],
        keitou: "法律・政治系統",
        gakka: ["法学", "政治学"],
        imgPath: "./images/icon_gakumonType02Link.svg",
        cd: ["gc110", "gc120"],
      },
    ],
    [
      {
        cls: ["Gakumon_270", "-Gakumon-type02"],
        keitou: "経済・経営・商学系統",
        gakka: ["経済学", "経営学･商学", "経営情報学"],
        imgPath: "./images/icon_gakumonType02Link.svg",
        cd: ["gc130", "gc140", "gc150"],
      },
    ],
    [
      {
        cls: ["Gakumon_280", "-Gakumon-type02"],
        keitou: "社会学系統",
        gakka: ["社会学", "社会福祉学", "環境学", "観光学", "マスコミ学"],
        imgPath: "./images/icon_gakumonType02Link.svg",
        cd: ["gc160", "gc170", "gc190", "gc200", "gc203"],
      },
    ],
    [
      {
        cls: ["Gakumon_290", "-Gakumon-type02"],
        keitou: "国際関係学系統",
        gakka: ["国際関係学"],
        imgPath: "./images/icon_gakumonType02Link.svg",
        cd: ["gc205"],
      },
    ],
    [
      {
        cls: ["Gakumon_300", "-Gakumon-type02"],
        keitou: "情報・メディア系統",
        gakka: ["情報学・データサイエンス", "メディア学"],
        imgPath: "./images/icon_gakumonType02Link.svg",
        cd: ["gc210", "gc215"],
      },
    ],
    [
      {
        cls: ["Gakumon_310", "-Gakumon-type03"],
        keitou: "理学系統",
        gakka: ["数学", "物理学", "化学", "生物学", "地球科学"],
        imgPath: "./images/icon_gakumonType03Link.svg",
        cd: ["gc220", "gc230", "gc240", "gc250", "gc260"],
      },
    ],
    [
      {
        cls: ["Gakumon_320", "-Gakumon-type03"],
        keitou: "工学系統",
        gakka: [
          "機械工学",
          "航空･宇宙工学",
          "医用工学･生体工学",
          "電気･電子工学",
          "通信･情報工学",
          "建築学",
          "土木･環境工学",
          "材料工学",
          "応用物理学",
          "応用化学",
          "生物工学",
          "資源･エネルギー工学",
          "経営工学",
          "船舶･海洋工学",
          "理工系その他",
        ],
        imgPath: "./images/icon_gakumonType03Link.svg",
        cd: [
          "gc270",
          "gc280",
          "gc285",
          "gc290",
          "gc300",
          "gc310",
          "gc320",
          "gc330",
          "gc340",
          "gc350",
          "gc360",
          "gc370",
          "gc380",
          "gc390",
          "gc400",
        ],
      },
    ],
    [
      {
        cls: ["Gakumon_330", "-Gakumon-type03"],
        keitou: "農・獣医・畜産系統",
        gakka: [
          "農学･農芸化学",
          "農業工学･林学",
          "農業経済学",
          "獣医学",
          "酪農･畜産学",
          "水産学",
        ],
        imgPath: "./images/icon_gakumonType03Link.svg",
        cd: ["gc410", "gc420", "gc430", "gc440", "gc450", "gc460"],
      },
    ],
    [
      {
        cls: ["Gakumon_340", "-Gakumon-type04"],
        keitou: "医学系統",
        gakka: ["医学"],
        imgPath: "./images/icon_gakumonType04Link.svg",
        cd: ["gc470"],
      },
    ],
    [
      {
        cls: ["Gakumon_350", "-Gakumon-type04"],
        keitou: "歯学系統",
        gakka: ["歯学"],
        imgPath: "./images/icon_gakumonType04Link.svg",
        cd: ["gc480"],
      },
    ],
    [
      {
        cls: ["Gakumon_360", "-Gakumon-type04"],
        keitou: "薬学系統",
        gakka: ["薬学"],
        imgPath: "./images/icon_gakumonType04Link.svg",
        cd: ["gc490"],
      },
    ],
    [
      {
        cls: ["Gakumon_370", "-Gakumon-type04"],
        keitou: "看護・医療技術系統",
        gakka: ["看護学", "医療技術"],
        imgPath: "./images/icon_gakumonType04Link.svg",
        cd: ["gc500", "gc510"],
      },
    ],
    [
      {
        cls: ["Gakumon_380", "-Gakumon-type04"],
        keitou: "保健・福祉系統",
        gakka: ["保健･福祉学"],
        imgPath: "./images/icon_gakumonType04Link.svg",
        cd: ["gc520"],
      },
    ],
    [
      {
        cls: ["Gakumon_390", "-Gakumon-type04"],
        keitou: "家政・生活系統",
        gakka: ["食物･栄養学", "被服学", "児童学", "住居学", "生活科学"],
        imgPath: "./images/icon_gakumonType04Link.svg",
        cd: ["gc530", "gc540", "gc550", "gc560", "gc570"],
      },
    ],
    [
      {
        cls: ["Gakumon_400", "-Gakumon-type04"],
        keitou: "スポーツ・健康系統",
        gakka: ["スポーツ・健康科学"],
        imgPath: "./images/icon_gakumonType04Link.svg",
        cd: ["gc580"],
      },
    ],
  ];

  /**
   * 検索結果 設置区分データ
   */
  public static ritsuKubunData: ritsuKubunData[] = [
    {
      title: "国立",
      value: 2,
    },
    {
      title: "公立",
      value: 3,
    },
    {
      title: "私立",
      value: 1,
    },
  ];

  /**
   * 検索結果 エリアデータ
   */
  public static areaData: areaData[] = [
    {
      title: "北海道",
      value: 1,
    },
    {
      title: "東北",
      value: 2,
    },
    {
      title: "東京",
      value: 3,
    },
    {
      title: "関東(東京を除く)",
      value: 4,
    },
    {
      title: "信越・北陸",
      value: 5,
    },
    {
      title: "東海",
      value: 6,
    },
    {
      title: "大阪",
      value: 7,
    },
    {
      title: "近畿(大阪を除く)",
      value: 8,
    },
    {
      title: "中国・四国",
      value: 9,
    },
    {
      title: "九州・沖縄",
      value: 10,
    },
  ];

  /**
   * 検索結果 関連するSDGsデータ
   */
  public static SDGsData: SDGsData[] = [
    { value: 1 },
    { value: 2 },
    { value: 3 },
    { value: 4 },
    { value: 5 },
    { value: 6 },
    { value: 7 },
    { value: 8 },
    { value: 9 },
    { value: 10 },
    { value: 11 },
    { value: 12 },
    { value: 13 },
    { value: 14 },
    { value: 15 },
    { value: 16 },
    { value: 17 },
  ];
}
